export default __webpack_public_path__ + "static/icon-3-1-853575e13de787191625e8b92cca7fae.png";